module.exports = __webpack_public_path__ + "static/media/alert.e7e74fdc.svg";